import { genderOptions, positionOptions } from './../../../utils/selectOptions';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TextFieldComponent } from '../../text-field/text-field.component';
import {
  PrimaryContactForm,
  FormGroupTyped,
} from '../../../../core/types/interfaces';
import { Profile } from '../../../models/profile.model';
import { SelectComponent } from '../../select/select.component';

@Component({
  selector: 'app-primary-contact-info',
  templateUrl: './primary-contact-info.component.html',
  styleUrls: ['./primary-contact-info.component.scss'],
  imports: [TextFieldComponent, TranslatePipe, SelectComponent],
})
export class PrimaryContactInfoComponent {
  @Input() profile: Profile;
  @Input() formGroup: FormGroupTyped<PrimaryContactForm>;
  genderOptions = genderOptions;
  positionOptions = positionOptions;
  constructor() {}
}
